import React from 'react';
// import { makeStyles, shorthands } from '@fluentui/react-components';
import { ChatMessage } from '../../../../domain/messages/models/ChatMessage';
import { Text, Button, Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle, makeStyles, shorthands, tokens, List, ListItem } from '@fluentui/react-components';
import { Dismiss32Regular } from '@fluentui/react-icons';

import { AlwaysOnScrollBarStyles, Breakpoints, customColors, customFonts } from '../../../../styles';


const useStyles = makeStyles({
    surface: {
        width: 'min(360px, calc(100vw - 32px))',
        maxWidth: '1040px',
        height: 'max-content',
        ...shorthands.borderRadius('20px'),
        ...shorthands.padding('0px'),
        overflow: 'hidden',
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'inherit',
        backgroundColor: customColors.protivitiOffWhite,
    },
    header: {
        display: 'flex',
        aListItemgnItems: 'flex-start',
        justifyContent: 'space-between',
        ...shorthands.padding('28px', '28px', '0px', '28px'),
        backgroundColor: customColors.white,
        borderBottom: `1px soListItemd ${tokens.colorNeutralStroke2}`,
    },
    headerText: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.gap('6px'),
        minWidth: 0,
    },
    title: {
        fontFamily: customFonts.TitleFont,
        fontSize: '34px',
        ListItemneHeight: '1',
        color: customColors.summarizeButtonDarker,
        margin: '0',
    },
    closeButton: {
        marginBottom: '50px',
        ...Breakpoints.small({
            maxWidth: '24px',
            maxHeight: '24px',
        }),
    },
    subtitle: {
        fontFamily: customFonts.Lato,
        fontSize: '24px',
        color: customColors.buttonTextDarkBlue,
    },
    normalText: {
        fontFamily: customFonts.Lato,
        fontSize: '14px',
        color: customColors.black
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        ...shorthands.padding('22px', '28px', '28px', '28px'),
        ...shorthands.gap('22px'),
    },
    scrollRegion: {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        ...AlwaysOnScrollBarStyles,
    },
    list: {
        listStyleType: 'disc',
        paddingLeft: '20px',
    },
    listItem: {
        // display: 'list-item',
    },
    agentSource: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
        width: '100%',
    },
    agentSourceChips: {
        display: 'flex',
        width: 'fit-content',
        fontFamily: customFonts.Lato,
        fontSize: '14px',
        fontWeight: '700',
        color: customColors.protivitiDarkBlue,
        backgroundColor: customColors.white,
        ...shorthands.border('1px', 'solid', '#D9D9D9'),
        borderLeftWidth: '5px',
        borderLeftColor: '#D9D9D9',
        ...shorthands.borderRadius('5px'),
        ...shorthands.padding('8px', '12px'),
        justifyContent: 'flex-start',
        alignItems: 'center',
        transition: 'all 0.2s ease',
        cursor: 'default',
    },
});

interface ChatMessageInfoProps {
    message: ChatMessage;
    onClose: () => void;
}

const ChatMessageInfo: React.FC<ChatMessageInfoProps> = ({ message, onClose }) => {
    const styles = useStyles();

    return (
        <Dialog open onOpenChange={(_, data) => !data.open && onClose()}>
            <DialogSurface className={styles.surface}>
                <DialogBody className={styles.body}>
                    <div className={styles.header}>
                        <div className={styles.headerText}>
                            <DialogTitle className={styles.title}>Chat Message Info</DialogTitle>
                        </div>
                        <Button
                            appearance="transparent"
                            aria-label="Close dialog"
                            className={styles.closeButton}
                            icon={<Dismiss32Regular />}
                            onClick={onClose}
                        />
                    </div>

                    <DialogContent className={styles.content}>
                        <Text className={styles.subtitle}> Token Usage</Text>
                        <List className={styles.list}>
                            <ListItem className={styles.listItem}><Text className={styles.normalText}><strong>Input Tokens:</strong> {message.tokenUsage?.inputTokens ?? 'None'}</Text></ListItem>
                            <ListItem className={styles.listItem}><Text className={styles.normalText}><strong>Output Tokens:</strong> {message.tokenUsage?.outputTokens ?? 'None'}</Text></ListItem>
                            <ListItem className={styles.listItem}><Text className={styles.normalText}><strong>Total Tokens:</strong> {message.tokenUsage?.totalTokens ?? 'None'}</Text></ListItem>
                        </List>


                        <Text className={styles.subtitle}>Agent Sources</Text>
                        <div className={styles.scrollRegion}>
                            {message.agentSources && message.agentSources.length > 0 ? (
                                <div className={styles.agentSource}>
                                    {message.agentSources.map((agent, index) => (
                                        <Text
                                            key={index}
                                            className={styles.agentSourceChips}
                                        >
                                            {agent.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z]{2,})([A-Z][a-z])/g, "$1 $2").trim()}
                                        </Text>
                                    ))}

                                </div>) : (
                                <p>No sources available</p>
                            )}
                        </div>

                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default ChatMessageInfo;
